import styles from "./Navigation.module.css";
import SchoolIcon from "@mui/icons-material/School";
import PersonIcon from "@mui/icons-material/Person";
import WorkIcon from "@mui/icons-material/Work";
// import ComputerIcon from "@mui/icons-material/Computer";
import ArticleIcon from '@mui/icons-material/Article';

function Navigation({ aboutmeRef, educationRef, experiencesRef, papersRef }) {
  return (
    <nav className={styles.navigation}>
      <ul>
        <li
          onClick={() => {
            aboutmeRef.current.scrollIntoView({ behavior: "smooth" });
          }}
        >
          <PersonIcon sx={{ fontSize: 30 }} /> <span>About.me</span>
        </li>
        <li
          onClick={() => {
            educationRef.current.scrollIntoView({ behavior: "smooth" });
          }}
        >
          <SchoolIcon sx={{ fontSize: 30 }} /> <span>Education</span>
        </li>
        <li
          onClick={() => {
            experiencesRef.current.scrollIntoView({ behavior: "smooth" });
          }}
        >
          <WorkIcon sx={{ fontSize: 30 }} /> <span>Experiences</span>
        </li>
        <li
          onClick={() => {
            papersRef.current.scrollIntoView({ behavior: "smooth" });
          }}
        >
          <ArticleIcon sx={{ fontSize: 30 }} /> <span>Papers</span>
        </li>
        {/* <li
          onClick={() => {
            projectsRef.current.scrollIntoView({ behavior: "smooth" });
          }}
        >
          <ComputerIcon sx={{ fontSize: 30 }} /> <span>Projects</span>
        </li> */}
      </ul>
    </nav>
  );
}
export default Navigation;
